import { __assign, __awaiter, __generator } from "tslib";
import { useCallback } from "react";
import { getAdminApiUrl } from "@adsk/acs-sc-web-platform-api";
import { useRequests } from "./useRequests";
import { fetchAll } from "../utils/fetchHelpers";
import { FeatureFlag, ProjectEntitlementsVersion } from "../shared/constants";
import { useFeatureFlag } from "../shared/components/LaunchDarklyContext";
export var useProjects = function (accountId) {
  var _a = useFeatureFlag(FeatureFlag.PL_PROJECT_ENTITLEMENTS_V2, []),
    value = _a.value,
    loading = _a.loading;
  var apiVersion =
    loading || !value
      ? ProjectEntitlementsVersion.V1
      : ProjectEntitlementsVersion.V2;
  var fetchFn = useCallback(
    function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var fetchProjects, projectsResponse, projects;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              fetchProjects = function (apiVersion) {
                return fetchAll(
                  ""
                    .concat(getAdminApiUrl(), "/")
                    .concat(apiVersion, "/project-entitlements"),
                  __assign(
                    {
                      "filter[platform]": "acc",
                      "filter[classification]": "production,sample",
                      limit: "200",
                    },
                    accountId ? { "filter[accountId]": accountId } : undefined
                  )
                );
              };
              return [4 /*yield*/, fetchProjects(apiVersion)];
            case 1:
              projectsResponse = _a.sent();
              projects = projectsResponse.map(function (rawProject) {
                // Explicitly cast the rawProject as a Project
                return {
                  id: rawProject.id,
                  name: rawProject.name,
                  accountId: rawProject.accountId,
                };
              });
              // Return the transformed type
              return [2 /*return*/, { data: projects }];
          }
        });
      });
    },
    [accountId, apiVersion]
  );
  return useRequests(fetchFn);
};
